import React from "react";
import { Div } from "components/Base";
import { connect } from "react-redux";
import { getters } from "Portal/CallForPapersForm/model";

const decorate = connect(state => ({
  isViewingDraftSubmission: getters.isViewingDraftSubmission(state),
  isViewingOtherUserDraftSubmission: getters.isViewingOtherUserDraftSubmission(
    state
  ),
  isViewingDuplicateDraftSubmission: getters.isViewingDuplicateDraftSubmission(
    state
  )
}));

const Editing = ({
  isViewingDraftSubmission,
  isViewingOtherUserDraftSubmission,
  isViewingDuplicateDraftSubmission
}) => {
  return (
    <Div
      bg="warning2"
      bra={2}
      p={3}
      mb={3}
      display="row.center.center"
      tabIndex={0}
      fw={3}
      color="#494949"
    >
      {isViewingDraftSubmission && isViewingOtherUserDraftSubmission
        ? "You are viewing another user's draft session submission. You can save it as your own draft or submit it to complete the submission process. The original submitter will remain attached as the submitter of the session."
        : isViewingDraftSubmission && isViewingDuplicateDraftSubmission
        ? "You are editing your draft session submission, which was started by someone else. The original submitter will remain attached as the submitter of the session."
        : isViewingDraftSubmission
        ? "You are editing your draft session submission"
        : "You are editing your existing session submission"}
    </Div>
  );
};

export default decorate(Editing);
